module.exports = __webpack_public_path__ + "static/e-illu-4-1ee5d29f40a1a7363b8fdb394652d891.png";